import React from 'react';
import Route from './router'
import './App.css';
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core";
import { createTheme } from "@material-ui/core/styles";

import 'bootstrap/dist/css/bootstrap.min.css';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import Constant from './library/Constant';

if (sessionStorage.getItem('reloaded') != null) {
  // console.log('page was reloaded');
} else {
  // localStorage.removeItem(Constant.TOKEN)
  window.location.reload();
}
sessionStorage.setItem('reloaded', 'yes');

const THEME = createTheme({
  typography: {
   "fontFamily": "Poppins",
  //  "fontSize": 14,
   "fontWeightLight": 300,
   "fontWeightRegular": 400,
   "fontWeightMedium": 500
  }
});

function App() {
  return (
    <MuiThemeProvider theme={THEME}>
      <Route />
    </MuiThemeProvider>
  );
}

export default App;
